import { styled } from 'baseui'

export const AddressOptionRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
})

export const AddressDeleteIconButton = styled('button', {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '0 0.25rem',
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
})

export const ModalMessage = styled('p', {
  margin: 0,
})

export const ModalActionsRow = styled('div', {
  marginTop: '1rem',
  display: 'flex',
  gap: '0.5rem',
  justifyContent: 'center',
})

export const compactModalOverrides = {
  Dialog: {
    style: () => ({
      minHeight: 'auto',
      '@media screen and (min-width: 768px)': {
        width: '30rem',
        minHeight: 'auto',
      },
    }),
  },
}
